import PolicyComponent from './policy'
export default PolicyComponent
